import React from 'react';
import { MenuItem } from '../components/Menu';
import { ACTION_REFERRAL_MODAL, CATEGORY_GROWTH } from '../constants/analytics';
import giftIcon from '../icons/gift.svg';
import UIActions from '../ui/UIActions';
import { track } from '../utils/analytics';
import ReferralModal from './ReferralModal';
import { useAppDispatch } from '../app/redux/useAppSelector';

interface ReferralMenuItemProps {
  showIcon?: boolean;
}

const ReferralMenuItem = ({ showIcon = true }: ReferralMenuItemProps) => {
  const dispatch = useAppDispatch();
  const handleOpenReferralModal = () => {
    track(ACTION_REFERRAL_MODAL, { category: CATEGORY_GROWTH });
    dispatch(UIActions.openModal(ReferralModal));
  };

  return (
    // @ts-ignore-error
    <MenuItem
      icon={showIcon ? giftIcon : undefined}
      onClick={handleOpenReferralModal}
    >
      Refer & earn
    </MenuItem>
  );
};

export default ReferralMenuItem;
